import setTitleDomUtil from 'modules/dom/utils/set-title'
import setMetaTagDomUtil from 'modules/dom/utils/set-meta-tag'
import { logUtil } from 'packages/src'
import getMetaAttributesRouteUtil from 'modules/routes/utils/get-meta-attributes/index.js'

export default function setMetaAttributesRouteUtil (props) {
  const {
    title,
    description,
    tags,
    image,
    url,
    type
  } = getMetaAttributesRouteUtil(props)

  logUtil('setMetaAttributesRouteUtil').debug('props=', props)
  setTitleDomUtil(title)
  setMetaTagDomUtil('description', description)
  setMetaTagDomUtil('tags', tags)
  setMetaTagDomUtil('img', image)
  setMetaTagDomUtil('url', url)

  setMetaTagDomUtil('og:title', title)
  setMetaTagDomUtil('og:description', description)
  setMetaTagDomUtil('og:image', image)
  setMetaTagDomUtil('og:image:secure_url', image)
  setMetaTagDomUtil('og:image:alt', description)
  setMetaTagDomUtil('og:url', url)
  setMetaTagDomUtil('og:type', type)

  setMetaTagDomUtil('twitter:title', title)
  setMetaTagDomUtil('twitter:description', description)
  setMetaTagDomUtil('twitter:image', image)
}
